import { gql } from "generated-graphql";

export const GET_STAFF_CERS_UNMATCHED_EXPANSION = gql(`
  query StaffCersUnmatchedExpansion {
    staffCersUnmatchedExpansion {
      byTenant {
        tenantId
        tenantName
        cersBusinessId
        businessName
        unmatchedCount
      }
      stats {
        unmatchedTotal
        tenantsWithGaps
        netNewTotal
        netNewBusinesses
      }
    }
  }
`);

export const EXPORT_STAFF_CERS_UNMATCHED_EXPANSION = gql(`
  mutation ExportStaffCersUnmatchedExpansion {
    exportStaffCersUnmatchedExpansion {
      success
      downloadUrl
      errorMsg
    }
  }
`);
